import React from 'react';
import { Modal } from './modal';

import '../styles/dashboard.css';

import { Selectupgrade } from "./interactive/selectUpgrade.js";
import { Selectmwupurchase } from "./interactive/selectMwuPurchase.js";
import { SelectFinance } from "./interactive/selectFinance.js";

import { EntitiesArray } from './island';

export class Dashboard extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: false,
      parentCallback: this.props.parentCallback,
      defaultContent: this.props.children,
      mainActive: true
    }
  }

  createAlert = (msg) => {
    this.props.createAlert(msg);
  }

  handleModaltoggle = () => {
    if(this.state.mainActive === true) {
      this.setState({
        isOpen: !this.state.isOpen
      });
    } else {
      this.setState({
        parentCallback: {type: "default"}
      })
    }
  };

  callbackPurchase = (data) => {
    this.props.callbackPurchase(data);
  }

  mainActiveFalse = () => {
    if(this.state.mainActive){
      this.setState({
        mainActive: false
      })
    }
  }

  getInner = () => {
    if(this.state.parentCallback.type === "upgrade"){

      this.mainActiveFalse();
      return <Selectupgrade createAlert={this.createAlert} callbackPurchase={this.callbackPurchase} self={this.props.self} toBuy={this.state.parentCallback.id} stats={this.state.parentCallback.data} upgrades={this.props.self.getAvailableUpgrades()}/>

    } else if(this.state.parentCallback.type === "purchaseMwu"){
      this.mainActiveFalse();

      const gotNetwork = this.props.self.upgrades.filter((current) => {
        return current.name === "Netwerk";
      });
      let hasNetwork = (gotNetwork.length > 0 ? true : false);

      return <Selectmwupurchase createAlert={this.createAlert} funds={this.props.self.funds} callbackPurchase={this.callbackPurchase} hasNetwork={hasNetwork} self={this.props.self.name} stats={this.state.parentCallback.data} noNetwork={this.props.self.company} entities={EntitiesArray}/>
    } else if(this.state.parentCallback.type === "finance"){
      this.mainActiveFalse();
      return <SelectFinance createAlert={this.createAlert} finances={this.state.parentCallback.id} self={this.props.self} callbackPurchase={this.callbackPurchase}/>
    } else {
      if(!this.state.mainActive){
        this.setState({
          mainActive: true
        })
      }
      return this.props.children;
    }
  }

  render() {
    let width = "1200px";
    if(document.getElementById("maintainRatio") !== null){
      let elem = document.getElementById("maintainRatio").getAttribute("style");
      elem = elem.split(";")

      for (var i = 0; i < elem.length; i++) {
        if(elem[i].startsWith("width")){
          let n = elem[i].split(" ");
          width = n[n.length -1];
        }
      }
    }
    let color = (this.props.color !== undefined && this.props.color !== false ? this.props.color : this.props.self.color);

    return (
      <Modal maxWidth={width} show={this.state.isOpen}>
        <div className="dashboard">
          <header style={{backgroundColor: color}}>
            <div className="dashboard--headerText">
              {this.props.headerText} <span className="dashboard--headerText-dark">Dashboard</span>
            </div>
            <div className="close" onClick={this.handleModaltoggle}></div>
          </header>
          <div className="content">
            {this.getInner()}
          </div>
        </div>
      </Modal>
    )
  };
}



// WEBPACK FOOTER //
// ./src/components/dashboard.js